export const PAYABLE_PUBLISH_ACTION_VALUES = ['save', 'publish', 'complete'] as const

export const PAYABLE_PUBLISH_ACTION = {
  SAVE: 'save',
  PUBLISH: 'publish',
  COMPLETE: 'complete'
} as const

export type PayablePublishAction = (typeof PAYABLE_PUBLISH_ACTION_VALUES)[number]

export const PAYABLE_ACTION_MARK_PAID = 'markPaid' as const

export const STEP_ID = {
  SUPPLIER: 'supplier',
  OPERATIONAL: 'operational',
  PAYMENT: 'payment',
  REVIEW: 'review'
} as const

export type StepId = (typeof STEP_ID)[keyof typeof STEP_ID]

export const STEP_ORDER: readonly StepId[] = [STEP_ID.SUPPLIER, STEP_ID.OPERATIONAL, STEP_ID.PAYMENT, STEP_ID.REVIEW]

export const STEP_LABELS: Record<StepId, string> = {
  [STEP_ID.SUPPLIER]: 'Supplier',
  [STEP_ID.OPERATIONAL]: 'What it covers',
  [STEP_ID.PAYMENT]: 'Payment',
  [STEP_ID.REVIEW]: 'Publish'
}
